import { User } from 'lucide-react';
import { ContactNavLink } from '@/entities/contact';
import { cn } from '@/shared/utils';
import { useUsers } from '../model/UsersContext';

export interface HistoryUserAttributionProps {
    userId?: string | number | null;
    /** Passed to `getUserName` when the user directory has no match (e.g. note author name from API). */
    fallbackName?: string;
    /** Prefix before the user label, e.g. `by ` (default). Pass empty string when the parent supplies context. */
    prefix?: string;
    className?: string;
}

export function HistoryUserAttribution({ userId, fallbackName, prefix = 'by ', className }: HistoryUserAttributionProps) {
    const { getUser, getUserName } = useUsers();

    if (userId == null || userId === '') {
        return null;
    }

    const user = getUser(userId);
    const contactId = user?.contact?.contactId;
    const label = getUserName(userId, fallbackName) || String(userId);

    const badgeClassName = 'inline-flex items-center gap-1 rounded bg-muted px-1.5 py-0.5 font-mono text-[10px] text-foreground';

    return (
        <span className={cn('text-xs text-muted-foreground', className)}>
            {prefix}
            {contactId != null ? (
                <ContactNavLink contactId={contactId} className={cn(badgeClassName, 'hover:bg-muted/80 hover:underline')}>
                    <User className="h-3 w-3 shrink-0" aria-hidden />
                    {label}
                </ContactNavLink>
            ) : (
                <code className={badgeClassName}>{label}</code>
            )}
        </span>
    );
}
